// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-item .nav-link a{opacity:.25}.nav-item .nav-link a:hover{opacity:1}.parent-div{display:flex}a{text-decoration:none}`, "",{"version":3,"sources":["webpack://./resources/app/modules/course/CourseBuilder/Blocks/TabsBlock/index.scss"],"names":[],"mappings":"AACE,sBACE,WAAA,CAGF,4BACE,SAAA,CAIJ,YACE,YAAA,CAGF,EACE,oBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
